export const LOCALES = ['pt-BR', 'en', 'es'] as const;
export type Locale = (typeof LOCALES)[number];
export const SOURCE_LOCALE: Locale = 'pt-BR';

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

export function detectLocale(stored: string | null, languages: readonly string[]): Locale {
  if (isLocale(stored)) return stored;
  for (const language of languages) {
    if (isLocale(language)) return language;
    const base = language.split('-')[0];
    if (base === 'pt') return 'pt-BR';
    if (base === 'en') return 'en';
    if (base === 'es') return 'es';
  }
  return SOURCE_LOCALE;
}
